import React, {
  useState,
  useCallback,
  useEffect,
  useContext,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import StoreContext from "../../components/Store/Context";

import Sidebar from "../../components/Sidebar";
import {
  DeleteButton,
  EditButton,
  FulfillButton,
  Main,
  RemoveFulfillButton,
  SubTitle,
  Table,
  TableActions,
  Tables,
  Title,
} from "./transferlist";

import {
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Button,
} from "@mui/material";

import {
  Content,
  Filter,
  FilterTitle,
  CloseFilter,
  Indicators,
  FulfillModal,
  FulfillModalTitle,
  CloseFulfillModal,
  FormBox,
  DownloadExcelWrapper,
  Overlay,
} from "../../utils/stylesbase";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { API_URL } from "../../utils/env";

const convertDate = (date) => {
  if (!date) return "";

  date = date.split("/");
  const day = date[0];
  const month = date[1];
  const year = date[2];

  return new Date(`${year}-${month}-${day}`);
};

const convertDateBRtoEN = (date) => {
  if (!date) return "";

  date = date.split("/");
  const day = date[0];
  const month = date[1];
  const year = date[2];

  return `${year}-${month}-${day}`;
};

const TransferList = () => {
  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);

  const [transfers, setTransfers] = useState([]);
  const [filteredTransfers, setFilteredTransfers] = useState([]);
  const [activeFilter, setActiveFilter] = useState(false);
  const [filtersOptions, setFiltersOptions] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [indicators, setIndicators] = useState([]);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState(0);
  const [fulfillModalOpened, setFulfillModalOpened] = useState(false);
  const [recordsToFulfill, setRecordsToFulfill] = useState([]);
  const [selectedOrderRef, setSelectedOrderRef] = useState("");
  const [fulfillOption, setFulfillOption] = useState("add");
  const [selectedLines, setSelectedLines] = useState([]);

  const { sidebarClosed, userName, userPermissions, setSidebarClosed } =
    useContext(StoreContext);

  const tableRef = useRef(null);

  const [dateFilters, setDateFilters] = useState({
    registeredDateFormated: {
      start: "0001-01-02",
      end: "9999-12-08",
    },
  });

  const columnsNames = [
    {
      code: "orderRef",
      name: "#",
    },
    {
      code: "plataform",
      name: "Plataform",
    },
    {
      code: "name",
      name: "Name",
    },
    {
      code: "pax",
      name: "Pax",
    },
    {
      code: "ticketsDate",
      name: "Tickets Date",
    },
    {
      code: "contact",
      name: "Contact",
    },
    {
      code: "country",
      name: "Country",
    },
    {
      code: "sector",
      name: "Sector",
    },
    {
      code: "address",
      name: "Address",
    },
    {
      code: "routeMap",
      name: "Route Map",
    },
    {
      code: "pickupPoint",
      name: "Pickup Point",
    },
    {
      code: "currency",
      name: "Currency",
    },
    {
      code: "transferType",
      name: "Transfer Type",
    },
    {
      code: "price",
      name: "Price",
    },
    {
      code: "fulfilled",
      name: "Fulfilled",
    },
    {
      code: "fulfillDateFormated",
      name: "Fulfill Date",
    },
    {
      code: "dateOfRegistrationFormated",
      name: "Date of Registration",
    },
    {
      code: "comments",
      name: "Comments",
    },
    {
      code: "createdBy",
      name: "Created By",
    },
    {
      code: "lastEditBy",
      name: "Last Edit By",
    },
  ];

  const deleteTransfer = useCallback(
    (transferId, orderRef) => {
      if ([5].indexOf(userPermissions) !== -1) return;
      MySwal.fire({
        title: `Are you sure you want to delete the transfer on booking ${orderRef}?`,
        showCancelButton: true,
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          fetch(`${API_URL}transfers/delete.php?id=${transferId}`, {
            method: "POST",
          })
            .then((response) => response.json())
            .then((response) =>
              Swal.fire("Transfer removed successfully!!", "", "success").then(
                () => {
                  return navigate(0);
                }
              )
            );
        }
      });
    },
    [userPermissions]
  );

  const editTransfer = useCallback((transferId) => {
    navigate(`/transfer-update?id=${transferId}`);
  }, []);

  const fulfillTransfer = useCallback(
    async (orderRef, option) => {
      if ([5].indexOf(userPermissions) !== -1) return;
      fetch(`${API_URL}fulfill/get-all.php?order-ref=${orderRef}`)
        .then((response) => response.json())
        .then((response) => {
          setFulfillOption(option);
          setRecordsToFulfill(response);
          setSelectedOrderRef(orderRef);
          setReset(Math.random());
          setFulfillModalOpened(true);
        });
    },
    [userName, userPermissions]
  );

  const openFilter = useCallback(
    (filter) => {
      setSearch("");
      setActiveFilter(filter);
      let options = [];
      transfers.forEach((transfer) => {
        if (options.indexOf(transfer[filter]) === -1)
          options.push(transfer[filter]);
      });
      setFiltersOptions(options);
    },
    [transfers, setActiveFilter]
  );

  const closeFilter = useCallback(() => {
    setActiveFilter(false);
  }, [setActiveFilter]);

  const searchFilters = useCallback(
    (e) => {
      const search = e.target.value;
      const filter = activeFilter;
      setSearch(search);
      let options = [];
      transfers.forEach((transfer) => {
        if (options.indexOf(transfer[filter]) === -1)
          options.push(transfer[filter]);
      });
      options = options.filter((a) =>
        a ? a.toLowerCase().includes(search.toLowerCase()) : false
      );
      options = options.sort((a, b) => (a > b ? 1 : -1));
      setFiltersOptions(options);
    },
    [activeFilter, transfers]
  );

  const changeFilter = useCallback(
    (e, attribute, option) => {
      let newFilters = selectedFilters;
      if (e.target.checked) {
        if (newFilters.find((item) => item.attributeName === attribute)) {
          newFilters
            .find((item) => item.attributeName === attribute)
            .selecteds.push(option);
        } else {
          newFilters.push({ attributeName: attribute, selecteds: [option] });
        }
      } else {
        newFilters
          .find((item) => item.attributeName === attribute)
          .selecteds.splice(
            newFilters
              .find((item) => item.attributeName === attribute)
              .selecteds.indexOf(option),
            1
          );
      }

      setSelectedFilters(newFilters);
      setReset(Math.random());
    },
    [selectedFilters, activeFilter]
  );

  const changeDateFilter = useCallback(
    (e, filter, id) => {
      let newDateFilters = dateFilters;
      newDateFilters[filter][id] = e.target.value;
      setDateFilters(newDateFilters);
      setReset(Math.random());
    },
    [dateFilters]
  );

  const checkFilterIsActive = useCallback(
    (option) => {
      if (
        selectedFilters.find((item) => item.attributeName === activeFilter) &&
        selectedFilters
          .find((item) => item.attributeName === activeFilter)
          .selecteds.indexOf(option) !== -1
      )
        return true;
      else return false;
    },
    [activeFilter, selectedFilters, reset]
  );

  const checkIfColumnIsFiltered = useCallback(
    (column) => {
      let filters = [];

      transfers.forEach((transfer) => {
        if (filters.indexOf(transfer[column]) === -1)
          filters.push(transfer[column]);
      });

      const total = filters.length;

      if (
        !selectedFilters.find((filter) => filter.attributeName === column) ||
        !selectedFilters.find((filter) => filter.attributeName === column)
          .selecteds
      )
        return false;

      return (
        selectedFilters.find((filter) => filter.attributeName === column)
          .selecteds.length !== total
      );
    },
    [selectedFilters]
  );

  const selectAll = useCallback(() => {
    let newFilters = selectedFilters;

    let filter = newFilters.find(
      (filter) => filter.attributeName === activeFilter
    );

    transfers.forEach((transfer) => {
      if (filter.selecteds.indexOf(transfer[activeFilter]) === -1)
        filter.selecteds.push(transfer[activeFilter]);
    });

    newFilters.find(
      (filter) => filter.attributeName === activeFilter
    ).selecteds = filter.selecteds;

    setSelectedFilters(newFilters);
    setReset(Math.random());
  }, [activeFilter, selectedFilters]);

  const clearAll = useCallback(() => {
    let newFilters = selectedFilters;
    newFilters.find(
      (filter) => filter.attributeName === activeFilter
    ).selecteds = [];
    setSelectedFilters(newFilters);
    setReset(Math.random());
  }, [activeFilter, selectedFilters]);

  const resetFilters = useCallback(() => {
    //Seleciona todos os filtros possíveis
    let filters = [];

    columnsNames.forEach((attribute) => {
      transfers.forEach((ticket) => {
        if (filters.find((item) => item.attributeName === attribute.code)) {
          if (
            filters
              .find((item) => item.attributeName === attribute.code)
              .selecteds.indexOf(ticket[attribute.code]) === -1
          )
            filters
              .find((item) => item.attributeName === attribute.code)
              .selecteds.push(ticket[attribute.code]);
        } else {
          filters.push({
            attributeName: attribute.code,
            selecteds: [ticket[attribute.code]],
          });
        }
      });
    });
    setSelectedFilters(filters);
  }, [transfers]);

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      const elements = Array.from(e.target.elements);
      let body = [];
      elements.forEach((el) => {
        if (el.tagName === "INPUT") {
          const type = el.id.split("-")[0].trim();
          const id = el.id.split("-")[1].trim();
          if (el.checked) {
            body.push({
              type,
              id,
            });
          }
        }
      });
      if (fulfillOption === "add") {
        fetch(`${API_URL}fulfill/fulfill-several.php`, {
          method: "POST",
          body: JSON.stringify({ records: body, lastEditBy: userName }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.error) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
            } else {
              Swal.fire("Records fulfilled successfully!!", "", "success").then(
                () => {
                  return navigate(0);
                }
              );
            }
          });
      } else if (fulfillOption === "remove") {
        fetch(`${API_URL}fulfill/unfulfill-several.php`, {
          method: "POST",
          body: JSON.stringify({ records: body, lastEditBy: userName }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.error) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
            } else {
              Swal.fire(
                "Records fulfill removed successfully!!",
                "",
                "success"
              ).then(() => {
                return navigate(0);
              });
            }
          });
      }
    },
    [fulfillOption]
  );

  const toggleSelectedLine = useCallback(
    (ticketId) => {
      let newSelectedLines = selectedLines;
      if (newSelectedLines.indexOf(ticketId) === -1)
        newSelectedLines.push(ticketId);
      else newSelectedLines.splice(newSelectedLines.indexOf(ticketId), 1);
      setSelectedLines(newSelectedLines);
      setReset(Math.random());
    },
    [selectedLines]
  );

  useEffect(() => {
    fetch(`${API_URL}transfers/list-all.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        setTransfers(response);
        setFilteredTransfers(response);

        //Seleciona todos os filtros possíveis
        let filters = [];

        columnsNames.forEach((attribute) => {
          response.forEach((transfer) => {
            if (filters.find((item) => item.attributeName === attribute.code)) {
              if (
                filters
                  .find((item) => item.attributeName === attribute.code)
                  .selecteds.indexOf(transfer[attribute.code]) === -1
              )
                filters
                  .find((item) => item.attributeName === attribute.code)
                  .selecteds.push(transfer[attribute.code]);
            } else {
              filters.push({
                attributeName: attribute.code,
                selecteds: [transfer[attribute.code]],
              });
            }
          });
        });
        setSelectedFilters(filters);

        //Seta a maior e menor data de RegisteredDate
        let registeredDateStart = "";
        let registeredDateEnd = "";
        response.forEach((transfer) => {
          if (registeredDateStart === "") {
            registeredDateStart = transfer.registeredDateFormated;
            registeredDateEnd = transfer.registeredDateFormated;
          } else {
            if (
              convertDate(transfer.registeredDateFormated) <
              convertDate(registeredDateStart)
            )
              registeredDateStart = transfer.registeredDateFormated;
            if (
              convertDate(transfer.registeredDateFormated) >
              convertDate(registeredDateEnd)
            )
              registeredDateEnd = transfer.registeredDateFormated;
          }

          let dates = dateFilters;
          dates.registeredDateFormated.start =
            convertDateBRtoEN(registeredDateStart);
          dates.registeredDateFormated.end =
            convertDateBRtoEN(registeredDateEnd);
        });
      });
  }, [dateFilters]);

  //Atualiza os transfers filtrados
  useEffect(() => {
    const filteredItems = transfers.filter((transfer) => {
      let ok = true;
      selectedFilters.forEach((filter) => {
        if (filter.selecteds.indexOf(transfer[filter.attributeName]) === -1) {
          ok = false;
          return;
        }
      });
      if (
        convertDate(transfer.registeredDateFormated) <
          new Date(dateFilters.registeredDateFormated.start) ||
        convertDate(transfer.registeredDateFormated) >
          new Date(dateFilters.registeredDateFormated.end)
      ) {
        ok = false;
      }

      return ok;
    });
    setFilteredTransfers(filteredItems);
  }, [selectedFilters, reset, transfers, dateFilters]);

  useEffect(() => {
    let dollarTotal = 0;
    let realTotal = 0;
    let paxTotal = 0;
    filteredTransfers.forEach((transfer) => {
      if (transfer.currency === "$")
        dollarTotal += parseFloat(transfer.price || 0);
      else if (transfer.currency === "R$")
        realTotal += parseFloat(transfer.price || 0);
      paxTotal += parseInt(transfer.pax || 0);
    });
    setIndicators({
      dollarTotal: dollarTotal,
      realTotal: realTotal,
      paxTotal: paxTotal,
    });
  }, [filteredTransfers]);

  useEffect(() => setSidebarClosed(true), []);

  return (
    <Main>
      <Sidebar />
      <Content sidebarclosed={sidebarClosed.toString()}>
        {[1, 2, 5].indexOf(userPermissions) !== -1 && (
          <Indicators>
            <thead>
              <tr>
                <th>$ Total</th>
                <th>R$ Total</th>
                <th>Pax Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{indicators.dollarTotal}</td>
                <td>{indicators.realTotal}</td>
                <td>{indicators.paxTotal}</td>
              </tr>
            </tbody>
          </Indicators>
        )}
        <SubTitle>Transfer</SubTitle>
        <Title>List</Title>
        <DownloadExcelWrapper>
          <DownloadTableExcel
            filename="Transfer-List"
            sheet="transfer-list"
            currentTableRef={tableRef.current}
          >
            <Button variant="outlined" style={{ marginBottom: "20px" }}>
              Export to excel
            </Button>
          </DownloadTableExcel>
          <Button
            variant="outlined"
            style={{ marginBottom: "20px", marginLeft: "20px" }}
            onClick={resetFilters}
          >
            Reset Filters
          </Button>
        </DownloadExcelWrapper>
        <Tables>
          <Table ref={tableRef}>
            <thead>
              <tr>
                {columnsNames.map((column) => {
                  return (
                    <th
                      onClick={() => openFilter(column.code)}
                      className={`${
                        checkIfColumnIsFiltered(column.code) ? "active" : ""
                      }`}
                      key={column.code}
                    >
                      {column.name}
                    </th>
                  );
                })}
                <th className="sticky-right"></th>
              </tr>
            </thead>
            <tbody>
              {filteredTransfers.map((transfer) => {
                return (
                  <tr
                    key={transfer.id}
                    className={
                      selectedLines.indexOf(transfer.id) !== -1
                        ? "selected"
                        : transfer.fulfilled === "1"
                        ? "fulfilled"
                        : ""
                    }
                    onClick={() => toggleSelectedLine(transfer.id)}
                  >
                    <td>{transfer.orderRef}</td>
                    <td>{transfer.plataform}</td>
                    <td>{transfer.name}</td>
                    <td>{transfer.pax}</td>
                    <td>{transfer.ticketsDate}</td>
                    <td>{transfer.contact}</td>
                    <td>{transfer.country}</td>
                    <td>{transfer.sector}</td>
                    <td>{transfer.address}</td>
                    <td>{transfer.routeMap}</td>
                    <td>{transfer.pickupPoint}</td>
                    <td>{transfer.currency}</td>
                    <td>{transfer.transferType}</td>
                    <td>{transfer.price}</td>
                    <td>
                      {transfer.fulfilled === "1" ? (
                        <CheckBoxIcon />
                      ) : (
                        <CheckBoxOutlineBlankIcon />
                      )}
                    </td>
                    <td>{transfer.fulfillDateFormated}</td>
                    <td>{transfer.dateOfRegistrationFormated}</td>
                    <td>{transfer.comments}</td>
                    <td>{transfer.createdBy}</td>
                    <td>{transfer.lastEditBy}</td>
                    {[1, 4, 5].indexOf(userPermissions) !== -1 && (
                      <td className="sticky-right">
                        <Tooltip title="Edit" placement="top">
                          <EditButton
                            onClick={() => editTransfer(transfer.id)}
                          />
                        </Tooltip>
                        <Tooltip title="Delete" placement="top">
                          <DeleteButton
                            onClick={() =>
                              deleteTransfer(transfer.id, transfer.orderRef)
                            }
                          />
                        </Tooltip>
                        {transfer.fulfilled === "1" ? (
                          <Tooltip title="Remove Fulfill" placement="top">
                            <RemoveFulfillButton
                              onClick={() =>
                                fulfillTransfer(transfer.orderRef, "remove")
                              }
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip title="Fulfill" placement="top">
                            <FulfillButton
                              onClick={() =>
                                fulfillTransfer(transfer.orderRef, "add")
                              }
                            />
                          </Tooltip>
                        )}
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Tables>
        <Filter opened={(activeFilter !== false).toString()}>
          <FilterTitle>
            Filtering{" "}
            {activeFilter &&
              columnsNames.find((filter) => activeFilter === filter.code).name}
          </FilterTitle>
          <CloseFilter onClick={() => closeFilter()} />
          {activeFilter === "registeredDateFormated" ? (
            <div className="date-filter">
              <TextField
                id={`start-${activeFilter}`}
                label="Start Date"
                variant="outlined"
                name={`start-${activeFilter}`}
                type="date"
                value={dateFilters.registeredDateFormated.start}
                onChange={(e) => changeDateFilter(e, activeFilter, "start")}
              />
              <TextField
                id={`end-${activeFilter}`}
                label="End Date"
                variant="outlined"
                name={`end-${activeFilter}`}
                type="date"
                value={dateFilters.registeredDateFormated.end}
                onChange={(e) => changeDateFilter(e, activeFilter, "end")}
              />
            </div>
          ) : (
            <ul status={reset}>
              <div className="filters-actions">
                <span onClick={selectAll}>Select All</span>
                <span onClick={clearAll}>Clear All</span>
              </div>
              <div className="filters-search">
                <TextField
                  id="search"
                  label="Search"
                  variant="outlined"
                  name="search-transfer"
                  value={search}
                  onChange={searchFilters}
                />
              </div>
              <div class="filters-options">
                {filtersOptions.map((option) => {
                  return (
                    <li key={option}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              id={option}
                              name={option}
                              onChange={(e) =>
                                changeFilter(e, activeFilter, option)
                              }
                              checked={checkFilterIsActive(option)}
                            />
                          }
                          label={
                            activeFilter === "fulfilled"
                              ? option === "1"
                                ? "Yes"
                                : "No"
                              : option
                          }
                        />
                      </FormGroup>
                    </li>
                  );
                })}
              </div>
            </ul>
          )}
        </Filter>
        <Overlay opened={fulfillModalOpened.toString()}>
          <FulfillModal status={reset} opened={fulfillModalOpened.toString()}>
            <FulfillModalTitle>
              Select records to{" "}
              {fulfillOption === "add" ? "fulfill" : "remove fulfill"} on
              order-ref {selectedOrderRef}
            </FulfillModalTitle>
            <CloseFulfillModal onClick={() => setFulfillModalOpened(false)} />
            <FormBox
              component="form"
              noValidate
              autoComplete="off"
              onSubmit={onSubmit}
            >
              {recordsToFulfill.map((record) => (
                <FormGroup key={`${record.id}-${record.type}`}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id={`${record.type} - ${record.id}`}
                        name={record.id}
                        record-type={record.type}
                        inputProps={{
                          "record-type": record.type,
                        }}
                      />
                    }
                    label={`${record.type} ${
                      record.date ? `- ${record.date}` : ""
                    } ${record.sector ? `- ${record.sector}` : ""}`}
                  />
                </FormGroup>
              ))}
              <Button variant="outlined" type="submit">
                Save
              </Button>
            </FormBox>
          </FulfillModal>
        </Overlay>
      </Content>
    </Main>
  );
};

export default TransferList;
